<template>
  <div id="app">
    <ion-app>
      <ion-router-outlet :style="{ height: '100vh', overflowY: 'auto' }" />
    </ion-app>
  </div>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { CDN_FONT_HSE_SANS } from '@/config/cdn';

export default {
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  },
  data() {
    return {
      cdnFontHseSans: CDN_FONT_HSE_SANS
    };
  }
}
</script> 

<style scoped>
@font-face {
  font-family: 'HSESans';
  src: url('v-bind(cdnFontHseSans)') format('woff2');
  font-weight: normal;
  font-style: normal;
}

* {
  font-family: 'HSESans', sans-serif !important;
}

#app {
  height: 100vh;
  overflow: hidden;
}

/* Enable scrolling for ion-content in app mode */
:root {
  --ion-safe-area-top: env(safe-area-inset-top);
  --ion-safe-area-bottom: env(safe-area-inset-bottom);
}

ion-content {
  --overflow: auto;
}

.ion-page {
  height: 100vh;
  overflow-y: auto;
}
</style>
